import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import Navfirst from './Navfirst';

 
// Register Chart.js components
ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Title, Tooltip, Legend);



const SimpleFormModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    nickname: '',
    email: '',
    url: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Validate form data if needed
    alert("OK");
    setIsOpen(false);
  };

  return (
    <div>
      <button 
        onClick={() => setIsOpen(true)}
        style={{
          backgroundColor: '#4CAF50',
          color: 'white',
          border: 'none',
          padding: '10px 20px',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          transition: 'background-color 0.3s ease'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#45a049'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#4CAF50'}
      >
        Wishlist
      </button>

      {isOpen && (
        <div style={modalStyle}>
          <div style={modalContentStyle}>
            <div style={modalHeaderStyle}>
              <h2 style={modalTitleStyle}>Product Feedback Form</h2>
              <button 
                onClick={() => setIsOpen(false)}
                style={closeButtonStyle}
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} style={formStyle}>
              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  Nickname
                  <input 
                    type="text" 
                    name="nickname" 
                    required 
                    value={formData.nickname}
                    onChange={handleInputChange}
                    style={inputStyle}
                    placeholder="Enter your nickname"
                  />
                </label>
              </div>

              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  Email
                  <input 
                    type="email" 
                    name="email" 
                    required 
                    value={formData.email}
                    onChange={handleInputChange}
                    style={inputStyle}
                    placeholder="Enter your email"
                  />
                </label>
              </div>

              <div style={formGroupStyle}>
                <label style={labelStyle}>
                  URL
                  <input 
                    type="url" 
                    name="url" 
                    required 
                    value={formData.url}
                    onChange={handleInputChange}
                    style={inputStyle}
                    placeholder="Enter URL"
                  />
                </label>
              </div>

              <div style={buttonContainerStyle}>
                <button 
                  type="submit" 
                  style={{
                    ...submitButtonStyle,
                    marginRight: '10px'
                  }}
                >
                  Submit
                </button>
                <button 
                  type="button" 
                  onClick={() => setIsOpen(false)}
                  style={cancelButtonStyle}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000
};

const modalContentStyle = {
  backgroundColor: "#fff",
  borderRadius: "8px",
  width: "400px",
  maxWidth: "95%",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  position: "relative"
};

const modalHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "15px",
  borderBottom: "1px solid #e0e0e0"
};

const modalTitleStyle = {
  margin: 0,
  fontSize: "18px",
  fontWeight: "600",
  color: "#333"
};

const closeButtonStyle = {
  background: "none",
  border: "none",
  fontSize: "20px",
  cursor: "pointer",
  color: "#888"
};

const formStyle = {
  padding: "20px"
};

const formGroupStyle = {
  marginBottom: "15px"
};

const labelStyle = {
  display: "block",
  marginBottom: "5px",
  color: "#555",
  fontWeight: "500"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  fontSize: "14px"
};

const buttonContainerStyle = {
  display: "flex",
  justifyContent: "flex-end"
};

const submitButtonStyle = {
  backgroundColor: "#4CAF50",
  color: "white",
  border: "none",
  padding: "10px 20px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px"
};

const cancelButtonStyle = {
  backgroundColor: "#f44336",
  color: "white",
  border: "none",
  padding: "10px 20px",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "14px"
};

const PriceTrackerGraph = () => {
  const [graphData, setGraphData] = useState(null);

  useEffect(() => {
    // Fetch the first user's data
    const fetchData = async () => {
      try {
        const response = await axios.get('http://localhost:4002/api/users/'); // Adjust URL if needed
        const firstUser = response.data[0]; // Get the first user
        if (firstUser && firstUser.Wishlist && firstUser.Wishlist[0]) {
          const prices = firstUser.Wishlist[0].prices || [];
          
          setGraphData({
            productName: firstUser.Wishlist[0].name,
            labels: prices.map((_, index) => `Update ${index + 1}`),
            prices: prices,
            datasets: [
              {
                label: `Price Tracking: ${firstUser.Wishlist[0].name}`,
                data: prices,
                borderColor: 'rgb(16, 85, 140)', // Deep professional navy blue
                backgroundColor: 'rgba(16, 85, 140, 0.1)', // Light background fill
                borderWidth: 3,
                fill: true,
                tension: 0.4, // Smooth curve
                pointStyle: 'circle',
                pointRadius: 6,
                pointBorderColor: 'rgb(16, 85, 140)',
                pointBackgroundColor: 'white',
                pointHoverRadius: 8,
                pointHoverBackgroundColor: 'rgb(16, 85, 140)',
                pointHoverBorderColor: 'white',
                pointHoverBorderWidth: 2,
                spanGaps: true,
              }
            ],
          });
        } else {
          console.error('No price data found for the first user.');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };
    fetchData();
  }, []);

  if (!graphData) {
    return (
      <div className="flex justify-center items-center h-96 w-full">
        <div className="animate-pulse text-gray-600 text-xl font-semibold">
          Loading price tracking data...
        </div>
      </div>
    );
  }

  return (
    <>
    <Navfirst/>
    <div className='bg-yellow-100'>
      <SimpleFormModal/>
    <div className=" w-full max-w-6xl mx-auto bg-white rounded-xl shadow-2xl p-8 grid grid-cols-1 md:grid-cols-2 gap-10">
      {/* Graph Section */}
      <div className="col-span-1 w-full">
        <Line
          data={{
            labels: graphData.labels,
            datasets: graphData.datasets
          }}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 1.2,
            plugins: {
              tooltip: {
                mode: 'index',
                intersect: false,
                backgroundColor: 'rgba(0,0,0,0.8)',
                titleColor: 'white',
                bodyColor: 'white',
                borderColor: 'rgba(255,255,255,0.2)',
                borderWidth: 1,
                cornerRadius: 6,
                padding: 10,
              },
              legend: {
                display: true,
                position: 'top',
                labels: {
                  boxWidth: 24,
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                },
              },
              title: {
                display: true,
                text: `Price Tracking: ${graphData.productName}`,
                font: {
                  size: 20,
                  weight: 'bold',
                },
                padding: {
                  top: 15,
                  bottom: 25
                }
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'Update Sequence',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                },
                grid: {
                  color: 'rgba(0,0,0,0.05)',
                },
              },
              y: {
                title: {
                  display: true,
                  text: 'Price ($)',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                },
                beginAtZero: false,
                grid: {
                  color: 'rgba(0,0,0,0.05)',
                },
              }
            },
          }}
        />
      </div>
      
      <div className="col-span-1 w-full">
      <div className="bg-gray-50 p-6 rounded-xl h-full overflow-auto shadow-inner">
        <h3 className="text-2xl font-bold mb-6 text-center text-gray-900">
          Detailed Price History
        </h3>
        
        {/* Make the table container scrollable */}
        <div className="max-h-[300px] overflow-y-auto">
          <table className="w-full text-base">
            <thead className="sticky top-0 bg-gray-200 z-10">
              <tr>
                <th className="p-3 text-left font-semibold">Update</th>
                <th className="p-3 text-right font-semibold">Price</th>
                <th className="p-3 text-right font-semibold">Change</th>
              </tr>
            </thead>
            <tbody>
              {graphData.prices.map((price, index, arr) => (
                <tr
                  key={index}
                  className="border-b last:border-b-0 hover:bg-gray-100 transition-colors duration-200"
                >
                  <td className="p-3 text-left">{index + 1}</td>
                  <td className="p-3 text-right font-medium">₹{price.toFixed(2)}</td>
                  <td className={`p-3 text-right font-semibold ${
                    index > 0
                      ? price > arr[index-1]
                        ? 'text-green-600'
                        : 'text-red-600'
                      : 'text-gray-500'
                  }`}>
                    {index > 0
                      ? `${price > arr[index-1] ? '+' : ''}${((price - arr[index-1]) / arr[index-1] * 100).toFixed(2)}%`
                      : 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {/* Additional Product Information */}
        <div className="mt-6 pt-6 border-t-2 border-gray-200 text-base text-gray-800">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <span className="font-bold block mb-1">Product:</span>
              <p className="text-gray-700">{graphData.productName}</p>
            </div>
            <div>
              <span className="font-bold block mb-1">Total Updates:</span>
              <p className="text-gray-700">{graphData.prices.length}</p>
            </div>
            <div>
              <span className="font-bold block mb-1">Initial Price:</span>
              <p className="text-gray-700">₹{graphData.prices[0].toFixed(2)}</p>
            </div>
            <div>
              <span className="font-bold block mb-1">Latest Price:</span>
              <p className="text-gray-700">₹{graphData.prices[graphData.prices.length - 1].toFixed(2)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </div>
    </>
   
  );
};

export default PriceTrackerGraph;